// src/pages/auth/AccountCreated.jsx
import { Link, useLocation } from 'react-router';
import { CheckCircle, Car, Search, Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Cookies from "js-cookie";

export function AccountCreated() {
  const { t } = useTranslation('auth');
  const location = useLocation();

  // Prefer context passed by PaymentSuccessPage; fall back to cookie.
  const stateCtx = location.state as { customerType?: number } | null;
  const customerType =
    Number(stateCtx?.customerType) || Number(Cookies.get("customerType"));

  const isBuyer = customerType === 1;
  const dashboardPath = customerType === 2 ? "/dashboard" : "/dealer";
  const addVehiclePath =
    customerType === 2 ? "/dashboard/add-vehicle" : "/dealer/add-vehicle";

  return (
    <div className="w-full max-w-md">
      <div className="bg-white rounded-2xl p-10 shadow-xl border border-[#E5E7EB] text-center">
        <div className="w-20 h-20 bg-[#22C55E]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-[#22C55E]" />
        </div>
        <h1 className="text-3xl text-[#2D323A] mb-3">{t('account_created.title')}</h1>
        <p className="text-[#717182] mb-8">{t('account_created.description')}</p>

        <div className="grid grid-cols-3 gap-3 mb-8">
          <div className="bg-[#F5F7FA] rounded-xl p-3 flex flex-col items-center gap-2">
            <div className="text-[#1E6DFF]"><Search className="w-5 h-5" /></div>
            <span className="text-xs text-[#717182]">{t('account_created.features.browse')}</span>
          </div>
          <div className="bg-[#F5F7FA] rounded-xl p-3 flex flex-col items-center gap-2">
            <div className="text-[#1E6DFF]"><Heart className="w-5 h-5" /></div>
            <span className="text-xs text-[#717182]">{t('account_created.features.wishlist')}</span>
          </div>
          <div className="bg-[#F5F7FA] rounded-xl p-3 flex flex-col items-center gap-2">
            <div className="text-[#1E6DFF]"><Car className="w-5 h-5" /></div>
            <span className="text-xs text-[#717182]">
              {isBuyer ? t('account_created.features.browse') : t('account_created.features.add_vehicle')}
            </span>
          </div>
        </div>

        <div className="space-y-3">
          {!isBuyer && (
            <Link
              to={dashboardPath}
              className="block w-full py-3 bg-[#1E6DFF] text-white rounded-xl hover:bg-[#1557d9] transition-colors shadow-md"
            >
              {t('account_created.buttons.dashboard')}
            </Link>
          )}

          <Link
            to={isBuyer ? "/search" : addVehiclePath}
            className="block w-full py-3 border border-[#E5E7EB] text-[#2D323A] rounded-xl hover:bg-[#F5F7FA] transition-colors"
          >
            {isBuyer ? t('account_created.buttons.vehicles') : t('account_created.buttons.add_vehicle')}
          </Link>
        </div>
      </div>
    </div>
  );
}